import { useTriggerDesigns } from "./TriggerDesignsContext.ts";

export const useAddTrigger = () => {
  const { addTrigger } = useTriggerDesigns();
  return addTrigger;
};
